import { ComboboxItem, Flex, Stack, Text } from '@mantine/core';
import { Dropzone } from '@mantine/dropzone';
import { notifications } from '@mantine/notifications';
import React from 'react';
import classes from './DropZone.module.css';

type Props = {
  documentType: ComboboxItem;
  onFilesSelected: (files: File[]) => void;
};

export function DropZone({ onFilesSelected }: Props) {
  const handleFilesSelected = (files: File[]) => {
    onFilesSelected(files);
  };

  return (
    <Dropzone
      onDrop={handleFilesSelected}
      onReject={fileRejections => {
        fileRejections.forEach(fileRejection => {
          notifications.show({
            title: `Failed to upload ${fileRejection.file.name}`,
            message: fileRejection.errors.map(e => e.message).join('\n'),
            color: 'red',
          });
        });
      }}
      maxSize={2147483648} // 2GB
      style={{
        border: '1px dashed #b4bbc7',
        borderRadius: '16px',
        padding: '32px',
      }}
      maxFiles={5}
      accept={[
        'image/png',
        'image/jpg',
        'image/jpeg',
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // DOCX
        'text/plain',
        'audio/mpeg', // MP3
        'video/mp4',
        'audio/wav',
        'audio/aac',
        'audio/flac',
        'audio/ogg',
      ]}
    >
      <Stack justify={'center'} align={'center'}>
        <Flex>
          <Text size="lg" className={classes.uploadLabel}>
            Upload
          </Text>
          <Text size="lg" fw={600}>
            &nbsp;your clients data or just drop a file here (DOCX, PDF, XLSX, XLS, MP3, MP4, WAV)
          </Text>
        </Flex>
      </Stack>
    </Dropzone>
  );
}
